/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the account module.
 */
import keyMirror from 'key-mirror';

export default keyMirror({
  FETCH_DELEGATE_LIST: null,
  FETCH_DELEGATE_LIST_SUCCESS: null,
  FETCH_DELEGATE_LIST_FAIL: null,
  UPDATE_DELEGATE: null,
  UPDATE_DELEGATE_SUCCESS: null,
  UPDATE_DELEGATE_FAIL: null
});
